import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { withRouter } from 'react-router-dom';
import { NotificationManager } from 'react-notifications';
import http from '../../services/http';
import Loader from '../loader/loader';
import authActions from '../../actions/auth/auth';

class ChangePasswordRequestForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      values: {},
      errors: {},
      loading: false,
      successfullySent: false,
    };
  }

  onFieldChange = fieldName => e => {
    const { value } = e.target;

    this.setState(state => ({
      ...state,
      values: {
        ...state.values,
        [fieldName]: value,
      },
      errors: {
        ...state.errors,
        [fieldName]: null,
      },
    }));
  }

  onSubmit = async e => {
    e.preventDefault();
    this.setState({ loading: true });

    const { values } = this.state;

    try {
      await http.get(`/api/auth/reset-password?email=${encodeURIComponent(values.UserName)}&origin=${encodeURIComponent(window.location.origin)}`);
      this.setState({ loading: false });
    } catch (error) {
      console.error(error); // eslint-disable-line no-console

      this.setState({ loading: false });

      const errorMessage = error.errorMessage || 'Nie udało się wysłać danych!';
      NotificationManager.error(errorMessage, 'Błąd', 5000);

      const { errors } = error;

      if (errors) {
        this.setState({ errors });
      }

      return;
    }

    this.setState({ successfullySent: true });
  }

  renderField = (fieldName, label, props = {}) => {
    const { errors } = this.state;
    // eslint-disable-next-line react/destructuring-assignment
    const [error] = errors[fieldName] || [];

    return (
      <TextField
        onChange={this.onFieldChange(fieldName)}
        variant="outlined"
        label={label}
        error={!!error}
        helperText={error}
        fullWidth
        {...props}
      />
    );
  }

  render() {
    const { loading, successfullySent } = this.state;
    const { history } = this.props;

    return (
      <form className="login-form-container" onSubmit={this.onSubmit} noValidate>
        {loading && <Loader />}

        {successfullySent ? (
          <div>
            <div className="reset-password-text-container">
              <Typography variant="body1">
                Na podany adres został wysłany link do zresetowania hasła.
              </Typography>
            </div>

            <div className="send-button-container">
              <Button size="large" variant="contained" color="primary" onClick={() => history.replace('/')}>
                OK
              </Button>
            </div>
          </div>
        ) : (
          <div>
            <div className="reset-password-text-container">
              <Typography variant="body1">
                Podaj email, którego użyłeś podczas rejestracji.
                Na ten adres wyślemy link do zmiany hasła.
              </Typography>
            </div>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                {this.renderField('UserName', 'Login (e-mail)', { required: true, type: 'email' })}
              </Grid>
            </Grid>

            <div className="send-button-container">
              <Button size="large" variant="contained" color="primary" type="submit">
                Wyślij
              </Button>
            </div>
          </div>
        )}
      </form>
    );
  }
}

ChangePasswordRequestForm.propTypes = {
  history: PropTypes.shape({
    replace: PropTypes.func,
    push: PropTypes.func,
  }).isRequired,
  loginSuccess: PropTypes.func.isRequired,
};

const bindActions = {
  loginSuccess: authActions.loginSuccess,
};

export default connect(
  null,
  bindActions,
)(
  withRouter(ChangePasswordRequestForm),
);
